import { ConfirmDialog, LinearProgress, Typography } from '@occc/ui-design-system';

type RemoveUserFromLocationDialogProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => Promise<void>;
  isRemoveUserFromLocationInProgress?: boolean;
};

export const RemoveUserFromLocationDialog = ({
  open,
  setOpen,
  onConfirm,
  isRemoveUserFromLocationInProgress,
}: RemoveUserFromLocationDialogProps) => (
  <ConfirmDialog
    dialogTitle='Remove User From Location'
    confirmButtonText='Remove'
    open={open}
    onClose={() => setOpen(false)}
    confirmButtonProps={{
      onClick: onConfirm,
      color: 'error',
      disabled: isRemoveUserFromLocationInProgress,
    }}
  >
    {isRemoveUserFromLocationInProgress && <LinearProgress />}

    <Typography>
      Are you sure you would like to remove this User from this Location? This will not delete the
      user, only remove their access to this Location.
    </Typography>
  </ConfirmDialog>
);
